import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
    getMessaging,
    getToken,
    onMessage,
    isSupported,
} from "firebase/messaging";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const supported = await isSupported();
const userAgent = navigator.userAgent.toLowerCase();
const knownBrowser = !/edge|opr|opera|samsungbrowser/.test(userAgent);
const isOldIOS = /iphone|ipad|ipod/.test(userAgent) && /os (?:[0-9]|1[0-5])_/i.test(userAgent); // iOS versions 15 and below
const pushManagerSupported = "PushManager" in window && !isOldIOS; // Check for PushManager support and filter out older iOS
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
let messaging = supported && knownBrowser ? getMessaging() : null;

const swFile = process.env.REACT_APP_SW_FILE;

if ("serviceWorker" in navigator && pushManagerSupported) {
    navigator.serviceWorker
        .register(swFile)
        .then((registration) => {
            console.log("Service Worker registered with scope:", registration.scope);
        })
        .catch((error) => {
            console.error("Service Worker registration failed:", error);
        });
}

if ("serviceWorker" in navigator && pushManagerSupported) {
    navigator.serviceWorker.ready.then((registration) => {
        registration.pushManager
            .subscribe({
                userVisibleOnly: true,
                applicationServerKey: process.env.REACT_APP_FIREBASE_VAP_ID_KEY,
            })
            .then((subscription) => {
                console.log("User is subscribed:", subscription);
            })
            .catch((error) => {
                console.error("Failed to subscribe the user:", error);
            });
    });
}

export const requestForToken = (registration) => {
    if (!pushManagerSupported || !messaging) {
        console.warn("Push Manager or messaging not supported. Cannot request token.");
        return Promise.resolve(null);
    }
    return getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAP_ID_KEY,
        serviceWorkerRegistration: registration,
    }).then((res) => {
        return res;
    });
};

export const onMessageListener = () =>
    new Promise((resolve, reject) => {
        if (!messaging) {
            return reject(new Error("Messaging is not supported or not initialized"));
        }
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
